export default __webpack_public_path__ + "static/media/Amanda Suit - Cybersecurity and Business Analysis and Project Management Support Person.2b8da890.png";